<template>
    <div class="nopads">
        <span class="span-title">{{ $t('observation_filter.company') }}</span>
        <select
            id="companies"
            v-model="selectedCompany"
            class="form-select form-select-sm"
            :disabled="companies.length < 1"
        >
            <option :value="null">
                {{ $t('observation_filter.select_company') }}
            </option>
            <option
                v-for="option in companies"
                :key="option.id"
                :value="option.id"
            >
                {{ option.name }}
            </option>
        </select>
    </div>
</template>

<script>
import { restApi } from '../mixins/RestApiMixin'

export default {
    name: 'CompanyFilter',
    mixins: [restApi],
    props: {
        modelValue: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            companies: [],
            loading: false,
            selectedCompany: this.modelValue
        }
    },
    watch: {
        modelValue(newVal) {
            this.selectedCompany = newVal
        },
        selectedCompany(newVal) {
            this.$emit('update:modelValue', newVal)
        }
    },
    mounted() {
        this.fetchCompanies()
    },
    methods: {
        fetchCompanies() {
            this.loading = true
            this.restFetch(this.companyUrl, this.handleCompanies)
        },
        handleCompanies(response) {
            this.companies = response.data
            this.loading = false
        }
    }
}
</script>
